<script setup>
import { ref, onMounted } from "vue";
import { post } from "./../mixins/http_handler";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import gmapsInit from "@/utils/gmaps";
import {useRouter} from 'vue-router'

const router = useRouter()

const schema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().required("Email is required").email("Email is invalid"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^(\d{10})$/, "Phone number is in incorrect format"),
  zipCode: Yup.string().required("ZIP Code is required"),
  location: Yup.string().required("Location is required"),
});

const studioDetails = ref([]);
const zipLocations = ref([]);
const showLocations = ref(false);
const locationResponseMessage = ref('');

const customer = ref({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  zipCode: "",
});

const isLoadingSubmit = ref(false);

const searchBtnText = ref('Search');

const onSubmit = () => {
  isLoadingSubmit.value = true
  let signupurl = process.env.VUE_APP_CHECKOUT_URL + studioDetails.value.url_slug
  let customerInfo = "[" +
    '{name: "$email", value:"' +
    customer.value.email +
    '"}' +
    '{name: "$first_name", value:"' +
    customer.value.firstName +
    '"}' +
    '{name: "$last_name", value:"' +
    customer.value.lastName +
    '"}' +
    '{name: "name", value:"' +
    customer.value.firstName +
    ' '+
    customer.value.lastName +
    '"}' +
    '{name: "$phone_number", value:"' +
    customer.value.phone +
    '"}' +
    '{name: "email", value:"' +
    customer.value.email +
    '"}' +
    '{name: "signup_url", value:"' +
    process.env.VUE_APP_SIGNUP_URL + studioDetails.value.url_slug +
    '"}' +
    '{name: "checkout_url", value:"' +
    process.env.VUE_APP_CHECKOUT_URL + studioDetails.value.url_slug +
    '"}' +
    '{name: "source", value:"Beast Week"}' +
    '{name: "location_name", value:"' +
    studioDetails.value.Name +
    '"}' +
    '{name: "location_slug", value:"' +
    studioDetails.value.url_slug +
    '"}' +
    '{name: "utm_agency", value:"ILKBWS"}' +
    '{name: "utm_source", value:"website"}' +
    '{name: "utm_offer", value:"promo"}' +
    "]";
  let properties =
    "[" +
    '{name: "source", value:"Beast Week"}' +
    '{name: "source_url", value:"' +
    "https://" + process.env.VUE_APP_META_TAG_URL +
    '"}' +
    '{name: "signup_url", value:"' +
    process.env.VUE_APP_SIGNUP_URL + studioDetails.value.url_slug +
    '"}' +
    '{name: "checkout_url", value:"' +
    process.env.VUE_APP_CHECKOUT_URL + studioDetails.value.url_slug +
    '"}' +
    '{name: "location_name", value:"' +
    studioDetails.value.Name +
    '"}' +
    '{name: "utm_agency", value:"ILKBWS"}' +
    '{name: "utm_source", value:"website"}' +
    '{name: "utm_offer", value:"promo"}' +
    "]";
  post(
    "/",
    {
      query:
        `mutation {
              KlaviyotrackEvent(
                input: { event: "ILKBBeastWeek", customer: ` +
        customerInfo +
        `, properties: ` +
        properties +
        ` }
              )
            }`,
    },
    {
      Accept: "application/json",
      Authorization: process.env.VUE_APP_API_AUTH_TOKEN,
    }
  )
    .then((response) => {
      isLoadingSubmit.value = false
      if(response.data.data.KlaviyotrackEvent){
        router.push({
          name: 'Thankyou',
          query: {first_name: customer.value.firstName, url_slug: signupurl}
        });
      }
    })
    .catch((err) => {
      isLoadingSubmit.value = false
      console.log(err);
    });
};

onMounted(() => {
});

const getStudioDetails = (location) => {
  studioDetails.value = location;
};

const getLocationsByZipCode = async () => {
  searchBtnText.value = 'Fetching...'
  zipLocations.value = []
  studioDetails.value = []
  showLocations.value = false

  const google = await gmapsInit();
  const geocoder = new google.maps.Geocoder();
            geocoder.geocode({'address': customer.value.zipCode, 'region': 'us'}, function (results, status) {
                console.log('Results : ');
                console.log(results);
                if (status !== "OK" || !results[0]) {
                  showLocations.value = true
                  locationResponseMessage.value = 'Something went wrong please try again'
                  searchBtnText.value = 'Search';
                    throw new Error(status);
                }
                post("/", {
                    query:
                      `
                          query zipLocations($lat: String!, $lng: String!, $amount: Int = 25, $active: Boolean = true){
                                zipLocations(lat: $lat, long: $lng, amount: $amount, active: $active) {
                                ID
                                Name
                                lat
                                lng
                                Line1
                                Line2
                                City
                                state {
                                    ID
                                    Code
                                    State
                                    country {
                                    ID
                                    CountryName
                                    CountryCode
                                    }
                                }
                                ZipCode
                                phone
                                url_slug
                                }
                            }`,
                            variables: {
                              "lat": "'" + results[0].geometry.location.lat() + "'", "lng": "'" + results[0].geometry.location.lng() + "'"
                            }
                  })
                    .then((response) => {
                      showLocations.value = true
                      searchBtnText.value = 'Search'
                      zipLocations.value = response.data.data.zipLocations;
                      zipLocations.value.push({ID: 1, Name: "iLoveKickboxing - Unknown Location, FL", lat: 27.97, lng: -81.96, ZipCode:"33801", url_slug: "ilkb-unknown"});
                      if(zipLocations.value.length === 0 )
                        locationResponseMessage.value = 'No locations found'
                    })
                    .catch((err) => {
                      showLocations.value = true
                      locationResponseMessage.value = 'Something went wrong please try again'
                      searchBtnText.value = 'Search'
                      console.log(err);
                    });
            });

}
</script>

<template>
  <section class="section-wrapper getstarted-wrapper" id="getstarted">
    <div class="container-fluid position-relative">
      <div class="row d-flex justify-content-between">
        <div class="col-12 col-md-7">
          <h1>Registration is now Closed</h1>
          <p>Catch us in 2024 for our next Beast Week challenge Or Join our mailing list to stay up to date on future ILKB Challenges</p>
        </div>
        <div class="col-12 col-md-4">
            <div class="form_getstarted">
            <Form
              @submit="onSubmit"
              :validation-schema="schema"
              v-slot="{ errors }"
            >
              <div class="row row-mrl-12">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label>First Name</label>
                    <Field
                      type="text"
                      v-model="customer.firstName"
                      name="firstName"
                      id="firstName"
                      class="form-control"
                      :class="{ 'is-invalid': errors.firstName }"
                    />
                    <div class="invalid-feedback">{{ errors.firstName }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label>Last Name</label>
                    <Field
                      type="text"
                      v-model="customer.lastName"
                      name="lastName"
                      id="lastName"
                      class="form-control"
                      :class="{ 'is-invalid': errors.lastName }"
                    />
                    <div class="invalid-feedback">{{ errors.lastName }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12">
                  <div class="form-group">
                    <label>Email</label>
                    <Field
                        type="text"
                        v-model="customer.email"
                        name="email"
                        id="email"
                        class="form-control"
                        :class="{ 'is-invalid': errors.email }"
                    />
                    <div class="invalid-feedback">{{ errors.email }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12">
                  <div class="form-group">
                    <label>Phone Number</label>
                    <Field
                      type="text"
                      v-model="customer.phone"
                      name="phone"
                      id="phone"
                      class="form-control"
                      maxlength="10"
                      minlength="10"
                      :class="{ 'is-invalid': errors.phone }"
                    />
                    <div class="invalid-feedback">{{ errors.phone }}</div>
                  </div>
                </div>
                <div class="col-12 col-md-12">
                  <div class="form-group">
                    <label>Location</label>
                    <div class="row">
                      <div class="col-7 col-md-6">
                        <Field
                            type="text"
                            v-model="customer.zipCode"
                            name="zipCode"
                            id="zipCode"
                            class="form-control"
                            :class="{ 'is-invalid': errors.zipCode }"
                        />
                        <div class="invalid-feedback">{{ errors.zipCode }}</div>
                      </div>
                      <div class="col-5 col-md-6">
                        <button type="button" class="btn btn-secondary mt-0 zipcode_button" id="choose_location" :disabled="!customer.zipCode" v-on:click="getLocationsByZipCode()">{{searchBtnText}}</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="locations" class="col-12 col-md-12 ziplocation_box_wrapper" v-if="showLocations" :class="{ 'is-invalid': errors.location }">
                        <p class="small mt-2 mb-3" v-if="zipLocations.length === 0">{{ locationResponseMessage }}</p>
                        <p class="small mt-2 mb-3" v-if="zipLocations.length > 0">Your closest studio:</p>
                        <div id="closest_location_wrapper" v-if="zipLocations.length > 0">
                            <div>
                              <label class="radio-wrap mb-0" :for="'input-'+zipLocations[0].ID" >
                                <Field
                                    type="radio"
                                    name="location"
                                    :id="'input-'+zipLocations[0].ID"
                                    :value="zipLocations[0].ID"
                                    @change="getStudioDetails(zipLocations[0])"
                                    class="with-gap me-2 change_location"
                                />
                                <span>{{ zipLocations[0].Name }}</span>
                              </label>
                            </div>
                          </div>

                          <div v-if="zipLocations.length > 1" id="additional_locations_wrapper">
                            <template v-for="(location, index) in zipLocations">
                              <div v-if="index != 0" :key="location.ID">
                                <label class="radio-wrap" :for="'input-'+location.ID">
                                  <Field
                                      type="radio"
                                      name="location"
                                      :id="'input-'+location.ID"
                                      :value="location.ID"
                                      :class="{ 'is-invalid': errors.location }"
                                      @change="getStudioDetails(location)"
                                      class="with-gap me-2 change_location"
                                  />
                                  <span>{{ location.Name }}</span>
                                </label>
                              </div>
                            </template>
                          </div>
                    </div>
                <div class="invalid-feedback" v-if="zipLocations.length > 0">{{ errors.location }}</div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group text-center">
                    <button v-if="!isLoadingSubmit"
                      id="book_now"
                      type="submit"
                      class="btn btn-primary w-100"
                    >
                      Join Mailing List
                    </button>
                    <button id="book_now_loading"
                      type="button"
                      class="btn btn-primary w-100" v-else disabled>Submitting...</button>
                  </div>
                </div>
              </div>
            </Form>
            </div>
        </div>
      </div>
    </div>
  </section>
</template>
